import type { KarteUserFilteringRule, Range } from '@/types/app'

export const convertKarteUserFilteringRuleToLogData = (
  rules: KarteUserFilteringRule
) => ({
  annualIncomeRule: convertRange(rules.annualIncome),
  savingRule: convertRange(rules.saving),
  investmentRule: convertRange(rules.investment),
  totalAssetsRule: convertRange(rules.totalAssets),
  insuranceFeeRule: convertRange(rules.monthlyInsuranceFee),
  partnerAnnualIncomeRule: convertRange(rules.partnerAnnualIncome),
  prefectureRule: rules.prefecture?.toString() ?? 'none',
  partnerExistenceRule: convertMaybeBoolean(rules.hasPartner),
  childrenExistenceRule: convertMaybeBoolean(rules.hasChild),
  sexRule: rules.sex?.toString() ?? 'none',
  hasAnsweredRule: convertMaybeBoolean(rules.hasAnswered),
  generationRule: targetGeneration(rules.generation),
})

const targetGeneration = (generations: Range[]) =>
  generations.reduce(
    (accumulator, generation) => ({
      checkedUnderTwenties:
        accumulator.checkedUnderTwenties || generation.min === 0,
      checkedThirties: accumulator.checkedThirties || generation.min === 30,
      checkedFourties: accumulator.checkedFourties || generation.min === 40,
      checkedFifties: accumulator.checkedFifties || generation.min === 50,
      checkedOverSixties:
        accumulator.checkedOverSixties || generation.min === 60,
    }),
    {
      checkedUnderTwenties: false,
      checkedThirties: false,
      checkedFourties: false,
      checkedFifties: false,
      checkedOverSixties: false,
    }
  )

const convertRange = (range: Range): { min: number; max: number } => ({
  min: range.min ?? 0,
  max: range.max ?? Number.MAX_SAFE_INTEGER,
})

const convertMaybeBoolean = (
  value: boolean | null
): 'true' | 'false' | 'none' =>
  (value?.toString() as 'true' | 'false' | undefined) ?? 'none'
